// extracted by mini-css-extract-plugin
export default {"card":"styles_card__RNQDJ","containerImage":"styles_containerImage__5DRFC","containerFooter":"styles_containerFooter__BFqgr"};